import { Control, Controller, FieldValues, Path } from 'react-hook-form';
interface Option {
  id: number | string;
  label: string;
  value: string | number | boolean;
}

interface CustomSelectProps<TFieldValues extends FieldValues = FieldValues> {
  control: Control<TFieldValues>;
  name: string;
  label?: string;
  placeholder?: string;
  options: Option[];
  selectClassName?: string;
  labelClassName?: string;
  disable?: boolean;
}
const CustomSelect = <TFieldValues extends FieldValues = FieldValues>({
  control,
  name,
  label,
  placeholder,
  options,
  selectClassName = '',
  labelClassName = '',
  disable = false,
}: CustomSelectProps<TFieldValues>) => {
  return (
    <div className="flex flex-col gap-1 w-full">
      {label && <label className={labelClassName}>{label}</label>}

      <Controller
        name={name as Path<TFieldValues>}
        control={control}
        render={({ field, fieldState: { error } }) => (
          <>
            <select
              name={field.name}
              ref={field.ref}
              onBlur={field.onBlur}
              value={field.value === undefined || field.value === null ? '' : String(field.value)}
              onChange={(event) => {
                const selectedOption = options.find(
                  (option) => String(option.value) === event.target.value
                );
                field.onChange(selectedOption ? selectedOption.value : event.target.value);
              }}
              disabled={disable}
              className={`border rounded-md px-3 py-2 bg-white ${
                field.value === undefined || field.value === null || field.value === ''
                  ? 'text-gray-400'
                  : 'text-black'
              } ${selectClassName}`}
            >
              {placeholder && <option value="">{placeholder}</option>}

              {options.map((opt) => (
                <option key={opt.id} value={String(opt.value)}>
                  {opt.label}
                </option>
              ))}
            </select>

            {error && <p className="text-xs text-red-500 mt-1">{error.message}</p>}
          </>
        )}
      />
    </div>
  );
};

export default CustomSelect;
